<template>
	<div>
		<div class="row">
			<div class="col-md-12">
				<div class="card">
					<div class="card-header">Создание платежа</div>
					<div class="card-body">
						<b-alert variant="success"
							dismissible
							:show="showAlertSucces"
							@dismissed="showAlertSucces=false">
							Платёж успешно создан!
						</b-alert>

						<div class="row">
							<div class="col-md-6">
								<b-form @submit="onSubmitForm">
									<b-form-group label="Назначение" :class="{ 'has-error': $v.form.purpose.$error }">
										<b-form-textarea
										:rows="2"
											v-model.trim="form.purpose"
											required>
										</b-form-textarea>
										<b-form-invalid-feedback>{{ serverErrors.purpose }}</b-form-invalid-feedback>
									</b-form-group>
									<b-form-group label="Контрагент" :class="{ 'has-error': $v.form.counterparty.$error }">
										<b-form-textarea
										:rows="2"
											v-model="form.counterparty"
											required>
										</b-form-textarea>
										<b-form-invalid-feedback>{{ serverErrors.counterparty }}</b-form-invalid-feedback>
									</b-form-group>

									<div class="row">
										<div class="col-md-6">
											<b-form-group label="Сумма" :class="{ 'has-error': $v.form.amount.$error }">
												<b-form-input
													v-model="form.amount"
													required>
												</b-form-input>
											</b-form-group>

											<product-select v-if="loaded"
												:type="type"
												:product="form.productId"
												@changeProduct="setProductId"
											></product-select>

											<b-form-group label="Менеджер">
												<b-form-select v-model="form.menegerId" class="mb-3">
													<option :value="null" disabled>-- Выберите менеджера --</option>
													<option v-for="(user, key) in users" :key="key" :label="user.first_name + ' ' + user.last_name" :value="user.id" placeholder="asd"></option>
												</b-form-select>
											</b-form-group>

											<b-form-group horizontal :class="{ 'has-error': $v.form.date.$error }" label="Дата платежа" label-for="date" class="is-required">
												<date-picker id="date" @dp-change="doSetSystemDate" v-model="form.date" :config="datePickerConfig"></date-picker>
											</b-form-group>

											<b-form-group label="Битрикс ID" :class="{ 'has-error': $v.form.b24Id.$error }">
												<b-form-input v-model="form.b24Id" required></b-form-input>
												<b-form-invalid-feedback>{{ serverErrors.b24_id }}</b-form-invalid-feedback>
											</b-form-group>
										</div>
									</div>
								</b-form>
							</div>
						</div>
					</div>
					<div class="card-footer">
						<b-button variant="primary" @click="onSubmitForm">Сохранить изменения</b-button>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import moment from 'moment'
import { validationMixin } from 'vuelidate'
import { required, minLength, numeric } from 'vuelidate/lib/validators'
import datePicker from 'vue-bootstrap-datetimepicker'
import paymentApi from '@/api/modules/payment/payment'
import ProductSelect from '@/components/product/ProductSelect'
export default {
	components: {
		datePicker,
		'product-select': ProductSelect
	},
	data () {
		return {
			loaded: true,
			showAlert: false,
			showAlertSucces: false,
			type: null,
			companies: [],
			form: {
				amount: '',
				b24Id: '',
				date: '',
				companyId: '',
				menegerId: '',
				counterparty: '',
				purpose: '',
				productId: null
			},
			systemDate: '',
			datePickerConfig: {
				locale: 'ru',
				format: 'D MMMM, YYYY',
				useCurrent: true,
				date: ''
			},
			errors: {},
			serverErrors: {}
		}
	},
	mixins: [
		validationMixin
	],
	validations: {
		form: {
			counterparty: {
				required,
				minLength: minLength(5)
			},
			purpose: {
				required
			},
			amount: {
				required
			},
			date: {
				required
			},
			b24Id: {
				required,
				bitrix () {
					if (this.serverErrors.hasOwnProperty('b24_id')) {
						return false
					}
					return true
				},
				numeric
			}
		}
	},
	methods: {
		getUsers () {
			if (Object.keys(this.$store.state.userModule.users).length > 0) {
				const _users = this.$store.state.userModule.users
				for (let index in _users) {
					if ((_users[index].role === 'manager' || _users[index].role === 'supermanager') && _users[index].status === 1) {
						this.users.push(_users[index])
					}
				}
			}
		},
		setProductId (id) {
			this.form.productId = id
		},
		doSetSystemDate (e) {
			if (e.date !== false) this.systemDate = moment(e.date).format('YYYY-MM-DD')
		},
		onSubmitForm (e) {
			e.preventDefault()
			// this.$v.$touch()
			// if (this.$v.$invalid) return false
			// this.$v.$reset()
			let data = {
				amount: this.form.amount,
				b24_id: this.form.b24Id,
				date: this.systemDate,
				company_id: this.form.companyId,
				manager_id: this.form.menegerId,
				counterparty: this.form.counterparty,
				purpose: this.form.purpose,
				product_id: this.form.productId
			}

			paymentApi.create(data).then((result) => {
				// this.showAlertSucces = true
				this.cleanForm()
				this.$notify({
					group: 'success',
					type: 'success',
					title: 'Успех от слова успевать!',
					text: 'Платёж создан.'
				})
				setTimeout(_ => {
					this.$router.replace({path: `/payments/details/${result.id}/update`})
				}, 1000)
			}, (response) => {
				this.$v.$reset()
				this.errors = response.body.errors
				this.showAlert = true
				let i = 0
				for (let key in this.errors) {
					i++
					this.serverErrors[key] = this.errors[key][0]
					if (i === Object.keys(this.errors).length) this.$v.$touch()
				}
			})
		},
		cleanForm () {
			this.form = {}
			this.loaded = false
			setTimeout(_ => {
				this.loaded = true
			}, 1000)
		}
	},
	computed: {
		users () {
			const output = []
			const users = this.$store.getters['userModule/users']
			for (let index in users) {
				if ((users[index].role === 'manager' || users[index].role === 'supermanager') && users[index].status === 1) {
					output.push(users[index])
				}
			}

			return output
		}
	}
}
</script>
<style>
	.el-alert {
		margin-bottom: 15px;
	}
</style>



// WEBPACK FOOTER //
// src/pages/payment/create.vue